<template>
  <ValidationObserver>
    <div class="form-group">
      <label for="property.name">{{ $t('name') }}</label>
      <ValidationProvider name="name" vid="property.name" rules="required" v-slot="{ errors }">
        <input class="form-control" v-model="property.name" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="property.time.checkIn">{{ $t('checkIn') }}</label>
          <ValidationProvider name="name" vid="property.time.checkIn" rules="required" v-slot="{ errors }">
            <input type="time" class="form-control" v-model="property.time.checkIn" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="property.time.checkOut">{{ $t('checkOut') }}</label>
          <ValidationProvider name="name" vid="property.time.checkOut" rules="required" v-slot="{ errors }">
            <input type="time" class="form-control" v-model="property.time.checkOut" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="property.touristTaxt">{{ $t('touristTax') }}</label>
      <ValidationProvider name="name" vid="property.touristTax" rules="required" v-slot="{ errors }">
        <input type="number" class="form-control" v-model="property.touristTax" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <label for="property.stDodatnihLezisc">{{ $t('beds') }}</label>
      <ValidationProvider name="število dodatnih ležišč" vid="property.stDodatnihLezisc" rules="required" v-slot="{ errors }">
        <input type="number" class="form-control" v-model="property.stDodatnihLezisc" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
const countryList = require('country-list');

export default {
  name: 'Property',
  props: ['property']
}
</script>

<i18n>
{
  "en": {
    "name": "Name",
    "beds": "Additional Beds",
    "touristTax": "Tourist Tax",
    "checkIn": "Check-In Time",
    "checkOut": "heck-Out Time"
  },
  "sl": {
    "name": "Naziv",
    "beds": "Število dodatnih ležišč",
    "touristTax": "Turistična taksa",
    "checkIn": "Čas Check-Ina",
    "checkOut": "Čas Check-Outa"
  }
}
</i18n>
